import { Card, Text } from '@change/ds-core-ui/next';

import { InfoTooltip } from 'src/app/shared/components/tooltips';

import { useTracking } from '../../../../hooks/useTracking';
import type { NormalizedDecisionMaker } from '../../../../shared/types';
import { AvatarAndBadge } from '../../../shared/AvatarAndBadge';
import { DecisionMakerResponse } from '../../../shared/DecisionMakerResponse';
import { Name } from '../../../shared/Name';
import { ResponseBadge } from '../../../shared/ResponseBadge';

export const DecisionMakerCardMobile: React.FC<{ dm: NormalizedDecisionMaker }> = ({
	dm: { displayName, id, title, photoUrl, publiclyVisible, slug, response, signersText, type },
}) => {
	const { trackDMMoreInfoClick } = useTracking();
	return (
		<Card className="bg-white p-6 shadow-md lg:hidden">
			<div className="flex gap-4">
				<div>
					<AvatarAndBadge displayName={displayName} photoUrl={photoUrl} showDMIcon={type === 'POLITICIAN'} />
				</div>

				<div className="w-full">
					<div className="flex w-full flex-col flex-wrap xl:flex-row">
						<div className="w-full">
							<div className="mr-1 w-full">
								<div className="flex items-center gap-[6px]">
									<Name displayName={displayName} id={id} publiclyVisible={publiclyVisible} slug={slug} />
									{signersText && (
										<div className="flex items-center">
											<InfoTooltip
												aria-label="Information about signers"
												data-qa="dm-info-tooltip"
												onClick={() => trackDMMoreInfoClick(signersText)}
											>
												{signersText}
											</InfoTooltip>
										</div>
									)}
								</div>
							</div>

							<Text variant="body" className="mb-2 block">
								{title}
							</Text>
						</div>

						<div className="mb-2">
							<ResponseBadge response={response} />
						</div>
					</div>

					{response && <DecisionMakerResponse response={response} />}
				</div>
			</div>
		</Card>
	);
};
